import {
  Box,
  Button,
  Collapse,
  Container,
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import * as React from "react";
import { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import GroupIcon from "@mui/icons-material/Group";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import QrCodeIcon from "@mui/icons-material/QrCode";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import "../CSS/Home.css";
import CustomerHeader from "./global/CustomerHeader";
import CustomerFooter from "./global/CustomerFooter";
import { GET_MANAGE_BOOKING_DATA_RESET } from "../Constants/Constants";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

export default function Home(props) {
  // const token = JSON.parse(localStorage.getItem("userInfo"));
  const { decodedToken, checkUserPermission } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [openUsers, setOpenUsers] = React.useState(false);
  const [openProducts, setOpenProducts] = React.useState(false);
  const [openHXKiller, setOpenHXKiller] = React.useState(false);
  const [openLogs, setOpenLogs] = React.useState(false);

  const toggleOpenUsers = () => {
    setOpenUsers(!openUsers);
  };
  const toggleOpenProducts = () => {
    setOpenProducts(!openProducts);
  };
  const toggleOpenHXKiller = () => {
    setOpenHXKiller(!openHXKiller);
  };
  const toggleOpenLogs = () => {
    setOpenLogs(!openLogs);
  };

  const hasAccess = (allowedRoles) => allowedRoles.includes(decodedToken?.role);

  const GetLoggedInCustomer = useSelector((state) => state.GetLoggedInCustomer);
  const { loggedInCustomerInfo } = GetLoggedInCustomer;

  React.useEffect(() => {
    dispatch({ type: GET_MANAGE_BOOKING_DATA_RESET });
  }, []);

  console.log("hello home page")
  return (
    <>
      <CustomerHeader decodedToken={decodedToken} />
      <div className="dashboard">
        <div className="menu">
          <List component="nav" className="nasidebar">
            <ListItemButton component={Link} to="/dashboard">
              <HomeIcon className="icondeskbrdhm" />
              <ListItemText primary="DASHBOARDS" />
            </ListItemButton>

            {/* Users Section */}
            {hasAccess(["customer"]) && (
              <>
                <ListItemButton className="mintabcll" onClick={toggleOpenUsers}>
                  <GroupIcon className="icondeskbrd" />
                  <ListItemText primary="USERS" />
                  <IconButton edge="end">
                    {openUsers ? <ArrowDropUp /> : <ArrowDropDown />}
                  </IconButton>
                </ListItemButton>
                <Collapse in={openUsers} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItemButton
                      component={Link}
                      to="/dashboard/users/manageusers"
                    >
                      <KeyboardArrowRightIcon className="arolftarrow" />
                      <ListItemText primary="Edit/Delete User" />
                    </ListItemButton>
                    <ListItemButton
                      component={Link}
                      to="/dashboard/users/add-new-user/new"
                    >
                      <KeyboardArrowRightIcon className="arolftarrow" />
                      <ListItemText primary="Add New User" />
                    </ListItemButton>
                  </List>
                </Collapse>
              </>
            )}

            {/* Products Section */}
            {checkUserPermission(102, "can_view") ||
            checkUserPermission(103, "can_view") ? (
              <>
                <ListItemButton
                  className="mintabcll"
                  onClick={toggleOpenProducts}
                >
                  <QrCodeIcon className="icondeskbrd" />
                  <ListItemText primary="PRODUCTS" />
                  <IconButton edge="end">
                    {openProducts ? <ArrowDropUp /> : <ArrowDropDown />}
                  </IconButton>
                </ListItemButton>
                <Collapse in={openProducts} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {checkUserPermission(102, "can_view") && (
                      <ListItemButton
                        component={Link}
                        to="/dashboard/products/managemyitinerary"
                      >
                        <KeyboardArrowRightIcon className="arolftarrow" />
                        <ListItemText primary="Manage My Itinerary" />
                      </ListItemButton>
                    )}
                    {/* {decodedToken?.role === "customer" &&
                      checkUserPermission(103, "can_view") &&
                      loggedInCustomerInfo?.is_report_enabled && (
                        <ListItemButton
                          component={Link}
                          to="/dashboard/products/ticketreport"
                        >
                          <KeyboardArrowRightIcon className="arolftarrow" />
                          <ListItemText primary="Ticket Report" />
                        </ListItemButton>
                      )}
                    {decodedToken?.role === "customer_user" &&
                      checkUserPermission(103, "can_view") && (
                        <ListItemButton
                          component={Link}
                          to="/dashboard/products/ticketreport"
                        >
                          <KeyboardArrowRightIcon className="arolftarrow" />
                          <ListItemText primary="Ticket Report" />
                        </ListItemButton>
                      )} */}
                    {decodedToken?.role === "customer" &&
                      checkUserPermission(103, "can_view") &&
                      loggedInCustomerInfo?.is_report_enabled && (
                        <>
                         <ListItemButton
                              component={Link}
                              to="/dashboard/products/multipccticketreport"
                            >
                              <KeyboardArrowRightIcon className="arolftarrow" />
                              <ListItemText primary="Ticket Report" />
                            </ListItemButton>
                          
                           {/* {loggedInCustomerInfo?.customer_id === 577 && (
                              <ListItemButton
                            component={Link}
                            to="/dashboard/products/ticketreport"
                          >
                            <KeyboardArrowRightIcon className="arolftarrow" />
                            <ListItemText primary="Ticket Reporting" />
                          </ListItemButton>
                           
                          )} */}
                         
                        </>
                      )}
                    {decodedToken?.role === "customer_user" &&
                      checkUserPermission(103, "can_view") && (
                        <>
                         <ListItemButton
                              component={Link}
                              to="/dashboard/products/multipccticketreport"
                            >
                              <KeyboardArrowRightIcon className="arolftarrow" />
                              <ListItemText primary="Ticket Report" />
                            </ListItemButton>
                       
                         
                         {/* {decodedToken?.username === "jpedwa.test" && (
                             <ListItemButton
                            component={Link}
                            to="/dashboard/products/ticketreport"
                          >
                            <KeyboardArrowRightIcon className="arolftarrow" />
                            <ListItemText primary="Ticket Reporting" />
                          </ListItemButton>
                          )} */}
                        </>
                      )}
                  </List>
                </Collapse>
              </>
            ) : null}

            {hasAccess(["customer"]) && (
              <>
                <ListItemButton className="mintabcll" onClick={toggleOpenLogs}>
                  <InsertDriveFileIcon className="icondeskbrd" />
                  <ListItemText primary="Logs" />
                  <IconButton edge="end">
                    {openLogs ? <ArrowDropUp /> : <ArrowDropDown />}
                  </IconButton>
                </ListItemButton>
                <Collapse in={openLogs} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItemButton
                      component={Link}
                      to="/dashboard/logs/viewuserlogs"
                    >
                      <KeyboardArrowRightIcon className="arolftarrow" />
                      <ListItemText primary="View User Logs" />
                    </ListItemButton>
                  </List>
                </Collapse>
              </>
            )}
          </List>
        </div>
        <div className="content">
          <Outlet /> {/* This renders the dynamic content */}
        </div>
      </div>
      <CustomerFooter />
    </>
  );
}

{
  /* <Container sx={{ marginBottom: "5%" }}>
  <Box sx={{ mt: 10 }}>
    <Grid container spacing={3}>
      <Grid xs={12}>
        <Typography
          sx={{
            fontSize: 30,
            textAlign: "center",
            ml: 3,
            color: "#313639",
          }}
        >
          Welcome to Agent Portal
        </Typography>
      </Grid>
      <Grid sx={{ margin: 3, fontSize: 20, marginTop: 6 }} xs={12}>
        Profile
        <Divider sx={{ marginTop: 2 }} />
      </Grid>
      <Grid
        xs={12}
        sx={{
          marginLeft: 3,
          display: "flex",
          gap: 8,
        }}
      >
        {hasAccess(["customer", "user"]) && (
          <Paper elevation={6} sx={{ width: "20%", height: "130%" }}>
            <Button
              sx={{
                // backgroundColor: "#282828",
                color: "black",
                fontSize: 18,
                width: "100%",
                height: "100%",
                "&:hover": {
                  backgroundColor: "#282828",
                  color: "white",
                },
              }}
              onClick={() => {
                navigate("/profile");
              }}
            >
              Profile
            </Button>
          </Paper>
        )}
      </Grid>
      <Grid sx={{ margin: 3, fontSize: 20, marginTop: 10 }} xs={12}>
        Manage Users
        <Divider sx={{ marginTop: 2 }} />
      </Grid>
      <Grid
        xs={12}
        sx={{
          marginLeft: 3,
          display: "flex",
          gap: 8,
        }}
      >
        {hasAccess(["customer"]) && (
          <Paper
            elevation={6}
            sx={{ width: "20%", height: "130%", marginRight: 2 }}
          >
            <Button
              sx={{
                // backgroundColor: "#282828",
                color: "black",
                fontSize: 18,
                width: "100%",
                height: "100%",
                "&:hover": {
                  backgroundColor: "#282828",
                  color: "white",
                },
              }}
              onClick={() => {
                navigate("/manageusers");
              }}
            >
              Manage Users
            </Button>
          </Paper>
        )}
      </Grid>
      <Grid sx={{ margin: 3, fontSize: 20, marginTop: 10 }} xs={12}>
        Manage Products
        <Divider sx={{ marginTop: 2 }}></Divider>
      </Grid>
      <Grid
        xs={12}
        sx={{
          marginLeft: 3,
          display: "flex",
          gap: 8,
        }}
      >
        <Paper
          elevation={6}
          sx={{ width: "20%", height: "130%", marginRight: 2 }}
        >
          <Button
            sx={{
              // backgroundColor: "#282828",
              color: "black",
              fontSize: 18,
              width: "100%",
              height: "100%",
              "&:hover": {
                backgroundColor: "#282828",
                color: "white",
              },
            }}
            onClick={() => {
              // dispatch({ type: GET_MANAGE_BOOKING_DATA_RESET });
              navigate("/managemyitinerary");
            }}
          >
            Manage My Itinerary
          </Button>
        </Paper>

        <Paper elevation={6} sx={{ width: "20%", height: "130%" }}>
          <Button
            sx={{
              // backgroundColor: "#282828",
              color: "black",
              fontSize: 18,
              width: "100%",
              height: "100%",
              "&:hover": {
                backgroundColor: "#282828",
                color: "white",
              },
            }}
            onClick={() => {
              navigate("/ticketreport");
            }}
          >
            Ticket Report
          </Button>
        </Paper>
      </Grid>
    </Grid>
  </Box>
</Container>; */
}
